import React, { useEffect, useState } from "react";
import classes from "./ReportIssueModal.module.css";

// Report reasons map to the backend `response_rating` values 1-3 (4 is unused for now).
const REPORT_OPTIONS = [
  { value: 1, label: "Unrelated response" },
  { value: 2, label: "Vague/Unclear" },
  { value: 3, label: "Incorrect/invalid" },
];

const ReportIssueModal = ({ open, submitting = false, onClose, onSubmit }) => {
  const [rating, setRating] = useState(REPORT_OPTIONS[0].value);
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState(""); // "" | "error" | "success"

  // Reset the form each time the modal is (re)opened.
  useEffect(() => {
    if (open) {
      setRating(REPORT_OPTIONS[0].value);
      setRemark("");
      setStatus("");
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("");
    const ok = await onSubmit?.({ response_rating: rating, remark: remark.trim() });
    if (ok) {
      setStatus("success");
      setTimeout(() => onClose?.(), 1200);
    } else {
      setStatus("error");
    }
  };

  return (
    <div className={classes.overlay} onClick={onClose}>
      <div
        className={classes.modal}
        role="dialog"
        aria-modal="true"
        aria-label="Report Response"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className={classes.close}
          aria-label="Close"
          onClick={onClose}
        >
          &times;
        </button>
        <h3 className={classes.title}>Report Response</h3>
        <form onSubmit={handleSubmit}>
          <div className={classes.options}>
            {REPORT_OPTIONS.map((option) => (
              <label key={option.value} className={classes.option}>
                <input
                  type="radio"
                  name="report-reason"
                  value={option.value}
                  checked={rating === option.value}
                  onChange={() => setRating(option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
          <textarea
            className={classes.textarea}
            placeholder="Feedback or concern"
            value={remark}
            onChange={(event) => setRemark(event.target.value)}
            rows={3}
          />
          {status === "error" && (
            <p className={classes.error} role="alert">
              Couldn't submit your report. Please try again.
            </p>
          )}
          {status === "success" && (
            <p className={classes.success} role="status">
              Thanks! Your report has been submitted.
            </p>
          )}
          <button
            type="submit"
            className={classes.submit}
            disabled={submitting || status === "success"}
          >
            {submitting ? "Submitting…" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReportIssueModal;
